import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface ReceiptPoAssignment {
  poId: number;
  receiptId: number;
  receiptStatus: number;
  receiptStatusDate: string;
  receiptDate: string;
}

interface RequestParams {
  receiptId?: number;
  poId?: number;
}

const useReceiptPoAssignmentApi = () => {
  const call = useCallback(async ({ receiptId, poId }: RequestParams = {}) => {
    try {
      const res = await axiosInstance.put<ReceiptPoAssignment>(
        api.changeReceiptPoAssignment(receiptId),
        undefined,
        {
          params: { poId },
        }
      );
      return res?.data as ReceiptPoAssignment;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { execute, isLoading } = useAsync(call, false);

  return {
    changeReceiptPoAssignment: execute,
    isLoading,
  };
};

export default useReceiptPoAssignmentApi;
